import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import { MovementEffect, STANDARD_MOVEMENT_TIME } from "../effects/movementEffect";
import type { Player } from "../player";
import { BlackHoleProjectile } from "../projectiles/blackHoleProjectile";
import { Fire } from "../things/fire";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class Flamethrower extends Weapon {
	static key = "Flamethrower";
	constructor(owner: Player, ammo: number = 15) {
		super(owner, ammo);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH_FIRE;
	}

	override getMuzzleFlashCount(): number {
		return 25;
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.HEAT_LAUNCHER;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.FLAMETROWER_LAUNCH));
		const RANGE = 4;
		const delta = directionDelta(direction);
		for (let n = 0; n < RANGE; n++) {
			const targetXY = this.owner.xy.add(delta.x * (n + 1), delta.y * (n + 1));
			if (!board.isInBounds(targetXY)) return;
			if (!board.isPassable(targetXY)) return;
			if (BlackHoleProjectile.blocksCell(board, targetXY)) return;

			const fire = new Fire(targetXY);
			board.addThing(fire);
			const time = (STANDARD_MOVEMENT_TIME / RANGE) * (n + 1);
			// Merged fire was removed; animate a throwaway flame (never added) so the stream still shows.
			const flyingFlame = fire.active ? fire : new Fire(targetXY);
			board.addEffect(new MovementEffect(flyingFlame, this.owner.xy, targetXY, time));
		}
	}

	static deserialize(data: any, owner: Player): Flamethrower {
		const gun = new Flamethrower(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
